import React from 'react';
import isMultiDomain from 'utils/isMultiDomain';
import Stack from 'components/Stack';
import GeneralDetailsCard from './GeneralDetailsCard';
import AdvancedSettingsCard from './AdvancedSettingsCard';
export function PlaylistEditor(_ref) {
  var playlist = _ref.playlist,
    playlistForm = _ref.playlistForm,
    _ref$withParentPlayli = _ref.withParentPlaylistsInfo,
    withParentPlaylistsInfo = _ref$withParentPlayli === void 0 ? false : _ref$withParentPlayli;
  var isDistributed = playlist !== null && playlist !== void 0 && playlist.domain_id ? isMultiDomain(playlist) : false;
  var isDeleted = playlist === null || playlist === void 0 ? void 0 : playlist.isDeleted;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(GeneralDetailsCard, {
    playlist: playlist,
    playlistForm: playlistForm,
    withParentPlaylistsInfo: withParentPlaylistsInfo,
    isDistributed: isDistributed,
    isDeleted: isDeleted
  }), /*#__PURE__*/React.createElement(AdvancedSettingsCard, {
    playlistForm: playlistForm,
    isDistributed: isDistributed,
    isDeleted: isDeleted
  }));
}
export default PlaylistEditor;